<template>
  <div class="box">
      <el-button type="primary" icon="el-icon-plus" @click="add">新建</el-button>
      <el-button :underline="false" type="danger" @click="delmessage" icon="el-icon-delete">删除</el-button>
      <!-- 表格 -->
      <div class="tab">
          <el-table :data="tableData" style="width: 100%;" border v-loading="loading" element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading" :header-row-style="{ 'font-weight': 'bold', 'color': '#9196A0' }"
              @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55">
              </el-table-column>
              <el-table-column prop="title" label="标题">
              </el-table-column>
              <el-table-column prop="sendobjects" label="发送对象">
                  <template slot-scope="scope">
                      {{ scope.row.sendobjects == '0' ? '全部' : '指定用户' }}
                  </template>
              </el-table-column>
              <el-table-column prop="releasetime" label="发布时间">
              </el-table-column>
              <el-table-column label="操作">
                  <template slot-scope="scope">
                      <el-link :underline="false" type="primary" @click="details(scope.row)">详情</el-link>
                  </template>
              </el-table-column>
          </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationBox">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="currentPage4" :page-sizes="[10, 20, 30, 40]" :page-size="10"
              layout="total, sizes, prev, pager, next, jumper" :total="total" class="pagination">
          </el-pagination>
      </div>
      <AddView :message="dialogFormVisible" @closeFunction='getDialogFormVisible' @add-success="messageListFunc">
      </AddView>
  </div>
</template>

<script>
import AddView from './components/AddView.vue';
import WifiApi from '@/api/wifi.js';
export default {
  data() {
      return {
          tableData: [],
          total: 0, // 总数
          currentPage4: 1,
          dialogFormVisible: false,
          loading: true, // 表格加载
          pageSize: 10, // 每页显示多少条数据
          selectedRows: [], // 全选/单选
      }
  },
  components: { AddView },
  methods: {
      // 详情
      details(row) {
          // let self = this;
          let params = row.id;
          this.$router.push({
              path: '/ybwifi/message/Detail',
              query: {
                  id: params
              }
          });
      },
      // 多选
      handleSelectionChange(val) {
          this.selectedRows = val;
      },
      // 版本列表
      messageListFunc(pageSize, page) {
          WifiApi.getMessageList({ pageIndex: page, pageSize: pageSize }).then(response => {
              // console.log(response.data);
              this.total = response.data.total
              this.tableData = response.data.records;
              this.loading = false
          }).catch(error => {
              // console.error(error);
          });
      },
      // 每页显示多少条数据
      handleSizeChange(val) {
          // console.log(`每页 ${val} 条`);
          this.pageSize = val;
          this.messageListFunc(this.pageSize, this.currentPage4);
      },
      handleCurrentChange(val) {
          // console.log(`当前页: ${val}`);
          this.currentPage4 = val;
          this.messageListFunc(this.pageSize, this.currentPage4);
      },
      // 新增
      add() {
          this.dialogFormVisible = true;
      },
      getDialogFormVisible(value) {
          this.dialogFormVisible = value;
      },
      // 删除
      delmessage() {
          const ids = this.selectedRows.map(row => row.id);
          const params = ids
              .map(id => Number(id)) // 将每个字符串转成数字
              .filter(id => !isNaN(id)) // 如果转换失败，就排除这个元
          // console.log(params);
          this.$confirm('此操作将永久删除此条信息, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              WifiApi.getDelMessage({ messageIds: params }).then(res => {
                  // console.log(res)
              }).catch(err => {
                  // console.log(err);
              });
              this.messageListFunc(this.pageSize, this.currentPage4);
              this.$message({
                  type: 'success',
                  message: '删除成功!'
              });
          }).catch(() => {
              this.$message({
                  type: 'info',
                  message: '已取消删除'
              });
          });
      },
  },
  mounted() {
      this.messageListFunc();
  },
}
</script>

<style>
.tab {
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/ybwifi/message/index.vue